export default "__VITE_PUBLIC_ASSET__b2eaf3f3__"